export default __webpack_public_path__ + "static/media/workspace.b5eded98.png";